import { render, staticRenderFns } from "./QuestionSummaryList.vue?vue&type=template&id=38b9ec28&scoped=true"
import script from "./QuestionSummaryList.vue?vue&type=script&lang=js"
export * from "./QuestionSummaryList.vue?vue&type=script&lang=js"
import style0 from "./QuestionSummaryList.vue?vue&type=style&index=0&id=38b9ec28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9ec28",
  null
  
)

export default component.exports